export default function sortCurrencies(a, b) {
    return (a.crypto && !b.crypto) || new Date(a.created) < new Date(b.created) ? -1 : 1;
}
